import React from "react";
import { RegistrationShell } from "../components/RegistrationShell";
import { useGeniusRegistration } from "../GeniusRegistrationContext";
import { useAnalytics } from "../../../contexts/AnalyticsContext";
import { JoinStudentIcon, JoinSchoolIcon } from "@assets";
import { FLOW_TYPES } from "../constants";
import styles from "../GeniusRegistrationModal.module.css";

export const IntentStep = () => {
  const { selectFlow, closeRegistration } = useGeniusRegistration();
  const {
    trackGeniusStudentRegistrationIntent,
    trackGeniusSchoolRegistrationIntent
  } = useAnalytics();

  const handleStudent = () => {
    trackGeniusStudentRegistrationIntent({ source: "genius_home" });
    selectFlow(FLOW_TYPES.STUDENT);
  };

  const handleSchool = () => {
    trackGeniusSchoolRegistrationIntent({ source: "genius_home" });
    selectFlow(FLOW_TYPES.SCHOOL);
  };

  return (
    <RegistrationShell
      title="How would you like to join?"
      onClose={closeRegistration}
      centerTitle
    >
      <div className={styles.intentGrid}>
        <button type="button" className={styles.intentCard} onClick={handleStudent}>
          <img src={JoinStudentIcon} alt="" className={styles.intentIconImg} />
          <span>Join as Student</span>
        </button>
        <button type="button" className={styles.intentCard} onClick={handleSchool}>
          <img src={JoinSchoolIcon} alt="" className={styles.intentIconImg} />
          <span>Join as School</span>
        </button>
      </div>
    </RegistrationShell>
  );
};
